import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants';
import { HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-home-takeover-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadHomeOnboardingTakeoverV2 = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [
				ONBOARDING_EXPERIENCES.IS_FOUNDING_ADMIN,
				...Object.values(HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS),
			],
		},
	});
};
